import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

const problems = [
  { title: "Months spent emailing people who never reply", detail: "Cold outreach has a sub-1% response rate. You deserve better than that." },
  { title: "The best investors only back people they already know", detail: "If you're not in the right network, you're invisible, even if your startup is exceptional." },
  { title: "Great deals fall through the cracks", detail: "Investors miss strong opportunities every day because discovery is random and unstructured." },
  { title: "Money flows to the wrong places", detail: "Without smart matching, capital gets misallocated and founders waste months chasing the wrong checks." },
];

const ProblemSection = () => {
  return (
    <section className="py-10 md:py-14" aria-label="Problems with traditional fundraising">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <p className="text-xs font-medium text-destructive/80 uppercase tracking-widest mb-3">The Problem</p>
            <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
              Fundraising isn't broken.{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-destructive to-orange-400">It's just badly designed.</span>
            </h2>
            <p className="max-w-xl mx-auto text-muted-foreground">
              The current system wastes everyone's time, founders, investors, and the ideas that deserve to exist.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-4">
            {problems.map((problem, i) => (
              <motion.div
                key={problem.title}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="rounded-xl bg-card/70 backdrop-blur-xl p-5 transition-all duration-300 hover:bg-card/90 group"
                style={{ borderLeft: "2px solid hsl(0 84% 60% / 0.4)", border: "1px solid hsl(0 84% 60% / 0.12)", borderLeftWidth: "2px", borderLeftColor: "hsl(0 84% 60% / 0.5)" }}
              >
                <div className="flex items-start gap-3">
                  <XCircle className="w-4 h-4 text-destructive shrink-0 mt-0.5" aria-hidden="true" />
                  <div>
                    <p className="text-sm font-semibold text-foreground mb-1 leading-snug">{problem.title}</p>
                    <p className="text-xs text-muted-foreground leading-relaxed">{problem.detail}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
